import React, { Component } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
class CustomFooter extends Component {
  render() {
    return (
      <Box sx={{ bgcolor: 'primary.main', p:0.5}} component="footer">
        <Typography variant="h6" align="center" color="common.white" gutterBottom>
          © สงวนลิขสิทธิ์ 2021 | กรมทรัพยากรน้ำ
        </Typography>
      </Box>
    )
  }
}
export default CustomFooter;

